import { format } from 'date-fns';

// Design System
import replaceStringVars from 'jl-design-system/utils/string/replaceStringVars';

// Checkout Forms
import { PHONE_NUMBER_UK_MOBILE } from 'checkout-forms/form/fields';

// Types
import { CollectorDetailsFormConfigProps } from './collectorDetails.types';

// Config
import CLICK_AND_COLLECT_DATES from './clickAndCollectDates';
import GIFT_MESSAGE from './giftMessage';
import GIFT_RECEIPT_CHECKBOX from './giftReceiptCheckbox';
import USER_EMAIL_ADDRESS from './userEmailAddress';
import getInternationalPhoneNumberConfig from '@utils/lazy/internationalPhoneNumberConfig';

export const COLLECTOR_DETAILS_FORM_ID = 'collectorDetailsForm';

export default function getCollectorDetailsFormConfig({
  containerClassName,
  dates,
  daysToShowPerPage,
  disabled,
  focusOnSelectedDayMessage,
  instruction,
  isCollectPlus,
  isGiftReceiptAvailable = false,
  isGiftReceiptSelected = false,
  maxPagesToShow,
  selectedDay,
  selectedDayMessageClassName,
}: CollectorDetailsFormConfigProps) {
  const PHONE_NUMBER = getInternationalPhoneNumberConfig({
    instruction: 'A UK mobile number will allow us to send a text when the order is ready to collect',
  });

  const dayPicker = dates
    ? {
        ...CLICK_AND_COLLECT_DATES,
        required: !selectedDay,
        dates,
        daysToShowPerPage,
        maxPagesToShow,
        containerClassName,
        selectedDay,
        selectedDayMessageTitle: selectedDay
          ? replaceStringVars('Collect from ${time} on ${date}', {
              time: (() => {
                const minutes = format(selectedDay, 'mm');
                return minutes === '00' ? format(selectedDay, 'ha') : format(selectedDay, 'h:mma');
              })(),
            })
          : undefined,
        selectedDayMessageClassName,
        instruction,
        focusOnSelectedDayMessage,
        disabled,
      }
    : undefined;

  const PHONE_NUMBER_FIELD = isCollectPlus ? { ...PHONE_NUMBER_UK_MOBILE, instruction: '' } : PHONE_NUMBER;

  const giftFields = [];

  if (isGiftReceiptAvailable) {
    giftFields.push({
      ...GIFT_RECEIPT_CHECKBOX,
      checked: isGiftReceiptSelected,
      giftFormId: 'giftReceipt',
    });

    if (isGiftReceiptSelected) {
      giftFields.push({
        ...GIFT_MESSAGE,
        giftFormId: 'giftReceipt',
      });
    }
  }

  return {
    id: COLLECTOR_DETAILS_FORM_ID,
    fields: [dayPicker, USER_EMAIL_ADDRESS, PHONE_NUMBER_FIELD, ...giftFields],
    submitButton: 'Continue to payment',
  };
}
